<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 light-background">
  <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
    <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
    <td mat-cell *matCellDef="let emp" class="cell-color">
      <div class="value" [innerHTML]="emp[column]"></div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let emprow; columns: displayedColumns" [hidden]="emprow.hide"></tr>
</table>
